
































































































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import MainPicture from '@/components/upload/mainPicture.vue'
import LimitDiscount from './limitDiscount.vue'
import BuyGetOne from './buyGetOne.vue'
import BuyOneGetOne from './buyOneGetOne.vue'
import BuyGetCoupon from './buyGetCoupon.vue'
import SecondHalf from './secondHalf.vue'
import TierDiscount from './tierDiscount.vue'
import PreSales from './preSales.vue'
import SecKill from './secKill.vue'
import Bargain from './bargain.vue'
import Group from './group.vue'
import FreeShipping from './freeShipping.vue'
import ProductPack from './productPack.vue'
import BuyGetGiveaway from './buyGetGiveaway.vue'
import ProductFilter from '../productFilter/index.vue'
import OutfitProduct from '../outfit/index.vue'
import MemberScope from '../memberScope/index.vue'
import PromotionActivityApi from '@/api/marketing/promotionActivity/index'
import draggable from 'vuedraggable'

@Component({
  components: {
    CustomForm,
    PicModal,
    MainPicture,
    LimitDiscount,
    BuyGetOne,
    BuyOneGetOne,
    BuyGetCoupon,
    SecondHalf,
    TierDiscount,
    PreSales,
    SecKill,
    Bargain,
    Group,
    FreeShipping,
    ProductPack,
    BuyGetGiveaway,
    ProductFilter,
    OutfitProduct,
    MemberScope,
    draggable,
  },
})
export default class PromotionActivity extends AbpBase {
  currentTab: string = 'basicForm'
  activityId: string = ''
  formItem = {
    name: '',
    beginTime: null,
    endTime: null,
    startPreheatTime: null,
    mainImage: '',
    frameId: '',
    isOpen: false,
    isPreheat: false,
    type: '',
    routerName: '',
    ruleConfig: {
      limitDiscountConfig: {
        discount: 0,
      },
      // buyGetOneConfig: {
      //   quantity: 0,
      // },
      buyGetOneConfig: {
        quantity: 1,
        count: 1,
      },
      halfPriceConfig: {
        quantity: 2,
      },
      fullGetCouponsConfig: {
        discountType: '满X元送券',
        value: 0,
        coupons: [],
      },
      tierDiscountConfig: {
        discountType: '满X元减X元',
        tierDiscounts: [
          {
            condition: 0,
            discount: 0,
          },
        ],
      },
      preSalesConfig: {
        balancePayStartTime: new Date(),
        balancePayEndTime: new Date(),
        expriedTime: 0,
      },
      groupConfig: {
        limitCount: 0,
        expriedTime: 0,
        isUseVirtualUser: true,
        deal: 0,
        description: '',
      },
      seckillConfig: {
        expriedTime: 0,
      },
      bargainConfig: {
        buyMethod: 0,
        bargainMethod: 0,
        allowBargainOwn: false,
        lowBargainCount: 0,
        validHours: 0,
        description: '',
      },
      freeShippingConfig: {
        discountType: '满X元包邮',
        value: 0,
        province: [],
      },
      productPackConfig: {
        packpPrice: 0,
        packCount: 0,
      },
      buyGetGiveawayConfig: {
        quantity: 0,
        products: [],
        type: 0,
        amount: 0,
      },
      memberScope: 'All',
      cumulativeWithOtherDiscount: false,
    },
    disseminateConfig: {
      ribbon: '',
      showOnHomePage: false,
      imageUrl: '',
      copyWriting: '',
      promotionImage: [],
    },
    productFilterConfig: {
      scope: 'condition',
      customProduct: false,
      brands: [],
      categories: [],
      years: [],
      season: [],
      price: {
        min: 0,
        max: 0,
      },
      discount: {
        min: 0,
        max: 0,
      },
      productIds: [],
    },
    promotionOutfitConfig: [
      // {
      //   outfitPrice: '',
      //   pictureUrl: '',
      //   promotionOutfitId: '',
      //   promotionOutfitProducts: [
      //     {
      //       promotionOutfitId: '',
      //       productId: '',
      //       pictureUrl: '',
      //       productName: '',
      //       brandName: '',
      //       productCode: '',
      //       marketPrice: 0,
      //       price: 0,
      //       displayOrder: 0
      //     }
      //   ]
      // }
    ],
  }

  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        validator: this.validBeginTime,
        trigger: 'change',
      },
    ],
    endTime: [
      {
        required: true,
        validator: this.validEndTime,
        trigger: 'change',
      },
    ],
  }

  ruleValidate3 = {
    // imageUrl: [
    //   {
    //     validator: this.validImage,
    //     trigger: "change"
    //   }
    // ]
  }
  validBeginTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).basicForm.validateField('endTime')
    }
    callback()
  }
  validEndTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.formItem.beginTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  validBalancePayStartTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择支付尾款开始时间'))
    } else {
      ;(this.$refs as any).ruleConfigForm.validateField('balancePayEndTime')
    }
    callback()
  }
  validBlancePayEndTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择支付尾款结束时间'))
    }
    if (value < this.formItem.ruleConfig.preSalesConfig.balancePayStartTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  validImage(rule, value, callback) {
    if (this.formItem.disseminateConfig.showOnHomePage) {
      if (!value) {
        callback('请选择弹窗图片')
      }
    }
    callback()
  }
  validNumber(rule, value, callback) {
    if (value <= 0) {
      callback(new Error('必须大于0'))
    }
    callback()
  }
  validTierDiscount(rule, value, callback) {
    console.log('valid tier discount', this.formItem.ruleConfig.tierDiscountConfig)
    this.formItem.ruleConfig.tierDiscountConfig.tierDiscounts.forEach((element) => {
      if (element.condition === null || element.discount === null) {
        callback(new Error('优惠条件不能为空'))
      }
    })
    callback()
  }

  get ruleConfigValidate() {
    if (this.formItem.type === 'limitDiscount') {
      return {
        discount: [
          {
            required: true,
            message: '折扣必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    // if (this.formItem.type === 'buyGetOne') {
    //   return {
    //     quantity: [
    //       {
    //         required: true,
    //         message: '起送件数必须大于0',
    //         validator: this.validNumber,
    //         trigger: 'blur',
    //       },
    //     ],
    //   }
    // }
    if (this.formItem.type === 'buyGetOne') {
      return {
        count: [
          {
            required: true,
            message: '购买件数必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    // if (this.formItem.type === 'fullGetCoupons') {
    //   return {
    //     count: [
    //       {
    //         required: true,
    //         message: '购买件数必须大于0',
    //         validator: this.validNumber,
    //         trigger: 'blur',
    //       },
    //     ],
    //   }
    // }
    if (this.formItem.type === 'halfPrice') {
      return {
        quantity: [
          {
            required: true,
            message: '件数必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    if (this.formItem.type === 'tierDiscount') {
      return {
        tierDiscounts: [
          {
            required: true,
            validator: this.validTierDiscount,
            trigger: 'blur',
          },
        ],
      }
    }
    if (this.formItem.type === 'freeShipping') {
      return {
        value: [
          {
            required: true,
            message: '必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    if (this.formItem.type === 'preSales') {
      return {
        balancePayStartTime: [
          {
            required: true,
            validator: this.validBalancePayStartTime,
            trigger: 'change',
          },
        ],
        balancePayEndTime: [
          {
            required: true,
            validator: this.validBlancePayEndTime,
            trigger: 'change',
          },
        ],
        expriedTime: [
          {
            required: true,
            message: '订单失效时间必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    if (this.formItem.type === 'group') {
      return {
        partnerCount: [
          {
            required: true,
            message: '多少人成团必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
        limitCount: [
          {
            required: true,
            message: '参团次数必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
        expriedTime: [
          {
            required: true,
            message: '拼团过期时间必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    if (this.formItem.type === 'secKill') {
      // return {
      //   expriedTime: [
      //     {
      //       required: true,
      //       message: '订单失效时间必须大于0',
      //       validator: this.validNumber,
      //       trigger: 'blur'
      //     }
      //   ]
      // }
    }
    if(this.formItem.type === 'bargain') {
      return {
        lowBargainCount: [
          {
            required: true,
            message: '帮砍人数必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
        validHours: [
          {
            required: true,
            message: '砍价有效期必须大于0',
            validator: this.validNumber,
            trigger: 'blur',
          },
        ],
      }
    }
    return null
  }
  get computeRuleConfig() {
    let obj = {}
    if (this.formItem.type === 'limitDiscount') {
      obj = this.formItem.ruleConfig.limitDiscountConfig
    }
    // if (this.formItem.type === 'buyGetOne') {
    //   obj = this.formItem.ruleConfig.buyGetOneConfig
    // }
    if (this.formItem.type === 'buyGetOne') {
      obj = this.formItem.ruleConfig.buyGetOneConfig
    }
    if (this.formItem.type === 'fullGetCoupons') {
      obj = this.formItem.ruleConfig.fullGetCouponsConfig
    }
    if (this.formItem.type === 'halfPrice') {
      obj = this.formItem.ruleConfig.halfPriceConfig
    }
    if (this.formItem.type === 'tierDiscount') {
      obj = this.formItem.ruleConfig.tierDiscountConfig
    }
    if (this.formItem.type === 'freeShipping') {
      obj = this.formItem.ruleConfig.freeShippingConfig
    }
    if (this.formItem.type === 'preSales') {
      obj = this.formItem.ruleConfig.preSalesConfig
      obj['balancePayStartTime'] = this.formItem.ruleConfig.preSalesConfig.balancePayStartTime ? new Date(this.formItem.ruleConfig.preSalesConfig.balancePayStartTime) : ''
      obj['balancePayEndTime'] = this.formItem.ruleConfig.preSalesConfig.balancePayEndTime ? new Date(this.formItem.ruleConfig.preSalesConfig.balancePayEndTime) : ''
    }
    if (this.formItem.type === 'group') {
      obj = this.formItem.ruleConfig.groupConfig
    }
    if (this.formItem.type === 'secKill') {
      obj = this.formItem.ruleConfig.seckillConfig
    }
    if (this.formItem.type === 'bargain') {
      obj = this.formItem.ruleConfig.bargainConfig
    }
    if (this.formItem.type === 'productPack') {
      obj = this.formItem.ruleConfig.productPackConfig
    }

    if (this.formItem.type === 'buyGetGiveaway') {
      obj = this.formItem.ruleConfig.buyGetGiveawayConfig
    }
    obj['memberScope'] = this.formItem.ruleConfig.memberScope
    obj['cumulativeWithOtherDiscount'] = this.formItem.ruleConfig.cumulativeWithOtherDiscount
    return obj
  }
  async mounted() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      await this.loadActivity()
    }
    this.formItem.type = this.$route.meta.promotionType
    this.formItem.routerName = this.$route.name
  }
  async loadActivity() {
    await PromotionActivityApi.getPromotionActivity(this.activityId).then((res) => {
      console.log('load activity', res)
      this.formItem = res.data
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)
      this.formItem.startPreheatTime = new Date(res.data.startPreheatTime)

      this.formItem.type = this.$route.meta.promotionType
      this.formItem.routerName = this.$route.name
    })
  }
  get isAdd() {
    return this.activityId === ''
  }
  removeShareImg(index: number) {
    this.formItem.disseminateConfig.promotionImage.splice(index, 1)
  }
  imageUrlChange(list) {
    this.formItem.disseminateConfig.imageUrl = list[0].url
  }
  promotionImageChange(list) {
    list.forEach((item) => {
      this.formItem.disseminateConfig.promotionImage.push(item.url)
    })
  }
  selectPreheattime() {
    if(this.formItem.beginTime) {
      if(+this.formItem.startPreheatTime > +this.formItem.beginTime) {
        this.$Message.warning('主图预热时间不得大于活动开始时间')
        this.formItem.startPreheatTime = null
      }
    }
  }
  selectStarttime() {
    if(this.formItem.startPreheatTime) {
      if(+this.formItem.startPreheatTime > +this.formItem.beginTime) {
        this.$Message.warning('主图预热时间不得大于活动开始时间')
        this.formItem.startPreheatTime = null
      }
    }
  }
  /**
   * 选择图片
   */
  picChangeMain(e) {
    this.formItem.mainImage = e[0].frameUrl
    this.formItem.frameId = e[0].id
  }
  save() {
    var valid1 = (this.$refs['basicForm'] as any).validate()
    var valid2 =
      (this.$refs['ruleConfigForm'] as any).rules === null
        ? new Promise((resolver) => resolver(true))
        : (this.$refs['ruleConfigForm'] as any).validate()

    // var valid3 = (this.$refs["disseminateForm"] as any).validate();

    Promise.all([valid1, valid2]).then((values) => {
      console.log('values', values)
      var index = values.findIndex((x) => x === false)
      if (index > -1) {
        if (index === 0) this.currentTab = 'basicForm'
        if (index === 1) this.currentTab = 'ruleConfigForm'
        // if (index === 2) this.currentTab = "disseminateForm";
      } else {
        console.log('提交')
        if(this.formItem.isPreheat && !this.formItem.startPreheatTime) {
          this.$Message.warning('请选择主图预热时间')
          this.currentTab = 'basicForm'
          return
        }
        if (this.activityId === '') {
          PromotionActivityApi.addPromotionActivity(this.formItem).then((res) => {
            console.log('add promotion activity', res, this.formItem.routerName)
            this.$Message.success('保存成功')
            this.$router.replace({
              name: this.formItem.routerName,
              query: {
                id: res.data,
              },
            })
          })
        } else {
          PromotionActivityApi.updatePromotionActivity(this.activityId, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            // this.$router.push({
            //   name: this.formItem.type,
            // })
          })
        }
      }
    })
  }
}
